module.exports = __webpack_public_path__ + "img/pic1.f51db93a.jpg";